import { IconType } from "@common/declarations";
import classNames from "classnames";
import React from "react";
import Icon from "../component";

import "./style.less";

type Props = {
  isUnstyled?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  tooltip?: string | null;
};
const ExternalLink = ({ isUnstyled, ...props }: Props) => (
  <Icon
    {...props}
    className={classNames("external_link", { unstyled: isUnstyled })}
    icon={IconType.ExternalLink}
    onClick={props.onClick ? (e) => (e.stopPropagation(), props.onClick!()) : undefined}
  />
);
export default ExternalLink;

type ExternalLinkWithTextProps = Props & {
  text: string;
};
export const ExternalLinkWithText = ({ text, ...props }: ExternalLinkWithTextProps) => (
  <div className="external_link_container frc fg sm">
    <span>{text}</span>
    <ExternalLink {...props} />
  </div>
);
